import { render, staticRenderFns } from "./RewardToken.vue?vue&type=template&id=1ffa05b2&scoped=true&"
import script from "./RewardToken.vue?vue&type=script&lang=js&"
export * from "./RewardToken.vue?vue&type=script&lang=js&"
import style0 from "./RewardToken.vue?vue&type=style&index=0&id=1ffa05b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffa05b2",
  null
  
)

export default component.exports